import { format, isValid, parseISO } from 'date-fns'

import { EMPTY_LIST } from '../../../../../constants/common'
import { DATE_FULL_FORMAT } from '../../../../../constants/date'
import { PROFILE_ROUTE_NAMES } from '../../../../../constants/route'
import { LISTING_PROFILE_TAB_APPLICANTS } from '../../../RentalPortal.constants'

import { MATCH_UNAVAILABLE_REASON_KEY } from './ApplicantFitCheckBlock.constants'

export function getApplicantFitCheckMatch(applicantData) {
  return applicantData?.match ?? null
}

export function getApplicantFitCheckMetaLine({ match, t }) {
  const evaluatedAt = match.evaluated_at ? parseISO(match.evaluated_at) : null

  return t('RentalPortal.MatchEvaluatedLineKey', {
    date:
      evaluatedAt && isValid(evaluatedAt)
        ? format(evaluatedAt, DATE_FULL_FORMAT)
        : null,
    provided: match.provided_count,
    total: match.criteria_count,
  })
}

export function getApplicantFitCheckSuggestion({ criterion, match }) {
  return criterion.applicant_value == null
    ? ((match.suggestions ?? EMPTY_LIST).find(
        item => item.field === criterion.applicant_field
      ) ?? null)
    : null
}

export function getApplicantFitCheckMetaTooltip({ match, t }) {
  return t('RentalPortal.MatchRulesetVersionTooltipKey', {
    version: match.ruleset_version,
  })
}

export function getApplicantFitCheckUnavailableKey(match) {
  return (
    MATCH_UNAVAILABLE_REASON_KEY[match.unavailable_reason] ??
    'RentalPortal.MatchNotEvaluatedKey'
  )
}

export function getHasApplicantFitCheckRulesLink({ applicantData, match }) {
  return Boolean(
    match?.can_configure_matching && applicantData?.matched_listing
  )
}

export function getApplicantFitCheckRulesUrl(matchedListing) {
  return PROFILE_ROUTE_NAMES.rentalPortalListingProfile({
    additionalParams: `/${LISTING_PROFILE_TAB_APPLICANTS}`,
    id: matchedListing?.id,
  })
}
